import { Constants } from "../constants";

export const getExplorerUrl = (chain: string, txId: string) => {
    switch (chain) {
        case "XDC":
            return `${Constants.contractAddress.xdc.explorer}/txs/${txId}`;
    }
    throw new Error(`Unknown chain`);
};
export const getImageUrl = (name: string) =>
    `${window.location.origin}/wp-content/plugins/xdc-datachain-gateway/public/assets/${name}`;
